import { Helper } from "../../core/util/helper";
import { General } from "../../../siteManagement/general";
import { SheetEventType} from "../../../siteManagement/sheet";
import { Config } from "../../core/config/config";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Grid } from "../../core/components/grid";
import { AgreementLevelEntity, AgreementEntity } from "./agreement";
import { LevelAppProps } from "../level/level";
import { DialogHelper } from "../../core/util/dialogHelper";
import { EventType } from "../../../siteManagement/eventManager";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { KeyValuePair, StringKeyDictionary } from "../../commonInterfaces";
import {NotificationHelper} from "../../core/util/notificationHelper";
import React from "react"
export default class AgreementLevelGrid extends React.Component<AgreementLevelGridProps, any> {
    private _gridOptions: kendo.ui.GridOptions = null;
    private _translations: StringKeyDictionary<string> = null;

    constructor(props: AgreementLevelGridProps) {
        super(props);
        this._translations = props.context.translations;
        this._gridOptions = props.context.agreementLevelGridOptions;
        this._setEvents();
    }

    private _setEvents = () => {
        General.Events.bind(EventType.SavedSuccessfully, (data: any) => {
            if (data.context === "slaservicehours") {
                let serviceLevels = this.props.entity.Levels;
                let changedLevel = Helper.getArrayItem(serviceLevels, "ServiceHoursId", data.entity.Id);
                if (Helper.hasValue(changedLevel)) {
                    changedLevel.Calendar = data.entity.Calendar;
                    this.setState({});
                }
            }
        });
    }
    
    private _initCodeWindow = (entity: AgreementLevelEntity) => {
        const sheet = General.Sheet.Manager.createSheetWithUrl("SlaLevel/Edit?id=" + entity.LevelId, {}, {},true);
        sheet.bind(SheetEventType.SavedSuccessfully,
            (saved: LevelAppProps) => {
                HTTPService.post<JsonResultClass<AgreementLevelEntity>>("SlaAgreement/GetAgreementLevelForLevelId", { id: saved.entity.Id })
                    .then(result => {
                        const level = Helper.getArrayItem(this.props.entity.Levels, "LevelId", saved.entity.Id);
                        if (level != null) {
                            Helper.updateEntity(level, result.Data);
                        }
                        this.setState({});
                        });
            });
    }

    private _deleteLevel = (id: string) => {
       DialogHelper.confirm(this.props.field.customProps["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                let item = Helper.findObjIndex(this.props.entity.Levels, "LevelId", id);
                if (item >= 0) {
                    this.props.entity.Levels.splice(item, 1);
                    this.setState({});
                    this.props.onChange({ model: "entity.Levels" }, this.props.entity.Levels);
                }
            }
        });
    }

    private handleExternalNewDataCheck = (data: any) => {
        let result = false;
        if (data)
            result = data.active === "1";
        if (!result)
            NotificationHelper.showErrorMessage(Helper.getTranslation("Suche.ItemNotSelected"));
        return result;
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: AgreementLevelEntity) => {
        if (type == ToolBarStandardButtonType.NEW) {
            const url = "DynamicSearch/Window/SlaLevel/?multi=true&displayPattern=[[title]]&cus_ActiveOnly=true&disabled=active&active=1";
            const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, { disableTabTitle: true });
            sheet.setExternalNewDataCheck({check: this.handleExternalNewDataCheck});
            sheet.setTitle(this._translations["WebSMS.SLA.Agreement.LevelSuche"]);
            sheet.bind(SheetEventType.ItemsSelected, (ev) => {
                const data = ev.data;
                if (data.length > 0) {
                    let gridData = this.props.entity.Levels;
                    // nur die Levels die noch nicht im Agreement drin sind hinzufügen.
                    let list = data.filter(selLevel => gridData.filter(x => x.LevelId == selLevel.id || x.LevelSourceId == selLevel.id).length == 0)
                        .map((lvl) => lvl.id);
                    if (list.length > 0) {
                        // die Infos über Levels vom Server abfragen
                        HTTPService.post<JsonResultClass<AgreementLevelEntity[]>>("SlaAgreement/GetAgreementLevelList", {levelGuids: list} )
                            .then(result => {
                                let added = false;
                                for (let row of result.Data) {
                                    gridData.push(row);
                                    added = true;
                                }
                    
                                if (added){
                                    this.setState({});
                                    this.props.onChange({ model: "entity.Levels" }, this.props.entity.Levels);
                                }
                            });
                    }
                }
            });
        }
        else if (type == ToolBarStandardButtonType.EDIT) {
            if (dataItem.LevelSourceId == null)
                DialogHelper.alert(this._translations["WebSMS.SLA.Agreement.SaveBeforeLevelEdit"]);
            else
                this._initCodeWindow(dataItem);
        }
        else if (type == ToolBarStandardButtonType.DELETE) {
            this._deleteLevel(dataItem.LevelId);
        }
    }

    private _createGrid = () => {
        let editText = this.props.entity.RecordRight.CanWrite ? this._translations["WebSMS.SLA.Agreement.ConfigureLevel"] : this._translations["WebSMS.Common.View"];
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.add, enabled: this.props.entity.RecordRight.CanWrite });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: editText, enabled: this.props.entity.RecordRight.CanRead });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this.props.entity.RecordRight.CanWrite });

        let grid = (
            <Grid data={this.props.entity.Levels} options={this._gridOptions} id="agreementLevelGrid"
                standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton} />
        );
        return (grid)
    }

    render() {
        const grid = this._createGrid();
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <div className="flex-container flex-container__item" style={{ height: "300px" }}>                    
                    {grid}
                </div>
            </div>);

    }
};

interface AgreementLevelGridProps {
    context: { TypesOfDay: KeyValuePair<number, string>[], translations: StringKeyDictionary<string>, agreementLevelGridOptions: any};
    translations: StringKeyDictionary<string>;
    field: any;
    entity: AgreementEntity;
    onChange: (field, value) => void
}